<div class="Main-Street-Atla">
  <div class="company">
    <label>{{'company.CompanyAddress' | translate}}:</label>
    <div>{{policy?.addressLine1_Ext}}</div>
    <div>{{policy?.addressLine2_Ext}}</div>
    <div>{{policy?.city}}, {{policy?.state}}  {{policy?.zip}}</div>
  </div>
</div>
